import {loadDictOption} from './dict-service';

const normalizeDictTags = items => (
    (Array.isArray(items) ? items : [])
        .map(item => {
            const option = item && typeof item === 'object' ? item : {};
            const tag = String(option.itemValue || option.value || option.id || item || '');
            const label = String(option.itemText || option.label || option.name || tag);
            return {
                tag,
                intlLabel: {
                    id: `gui.libraryTags.${tag}`,
                    defaultMessage: label,
                    description: 'Tag for filtering a library'
                }
            };
        })
        .filter(item => item.tag && item.intlLabel.defaultMessage)
);

const loadLibraryTags = (dictCode, fallbackTags) =>
    loadDictOption(dictCode)
        .then(response => {
            if (response && response.success === false) {
                throw new Error(response.message || 'Library tag load failed');
            }
            const tags = normalizeDictTags(response && response.result);
            return tags.length ? tags : fallbackTags;
        })
        .catch(() => fallbackTags);

export {
    loadLibraryTags
};
